import { toast } from "sonner";
import { t } from "./i18n";

export type ShareResult = "shared" | "downloaded" | "copied";

const siteUrl = () => `${window.location.origin}/`;

const legacyCopy = (text: string) => {
  const ta = document.createElement("textarea");
  ta.value = text; ta.setAttribute("readonly", ""); ta.style.position = "fixed"; ta.style.opacity = "0";
  document.body.appendChild(ta); ta.select();
  let ok = false;
  try { ok = document.execCommand("copy"); } catch { ok = false; }
  document.body.removeChild(ta);
  return ok;
};

export async function shareLink(text: string, url = siteUrl()): Promise<ShareResult> {
  const nav = navigator as Navigator & { share?: (d: { title?: string; text?: string; url?: string }) => Promise<void> };
  const full = `${text} ${url}`;
  if (nav.share) {
    try { await nav.share({ title: "Roll Pup Roll: Cavern Escape", text, url }); return "shared"; } catch (e) { if ((e as Error).name === "AbortError") return "shared"; }
  }
  try { await navigator.clipboard.writeText(full); return "copied"; } catch { /* fall through */ }
  if (legacyCopy(full)) return "copied";
  toast.message(t("shareTitle"), { description: full, duration: 12000 });
  return "copied";
}

const fmtSec = (sec: number) => `${Math.floor(sec / 60)}:${String(sec % 60).padStart(2, "0")}`;

export const shareScore = (score: number, level: number, finished: boolean) =>
  shareLink(finished ? t("shareFinished", { s: score }) : t("shareText", { s: score, l: level }));

export const shareDaily = (score: number, wave: number, seconds: number, rank?: number | null) =>
  shareLink(`${t("shareDaily", { s: score, w: wave, t: fmtSec(seconds) })}${rank ? ` ${t("cardRank", { n: rank })}.` : ""}`);

export const packInviteUrl = (code: string) => `${siteUrl()}?copor=${code}`;
export const sharePackInvite = (code: string, name: string) => shareLink(t("shareInvite", { p: name }), packInviteUrl(code));
